import { get } from 'lodash'

import * as utils from './table.util'

const comparator = (a, b) => {
  if (typeof b === 'string') {
    return b.localeCompare(a)
  }

  if (a > b) {
    return -1
  }

  return a < b ? 1 : 0
}

const sortBy = (data, sort) => {
  if (!sort) {
    return data
  }

  const { field, func, order } = sort

  return data.slice().sort(
    func
      ? (a, b) => utils[func](a, b, order, field, a, b)
      : (a, b) => {
          const valueA = get(a, field) ?? ''
          const valueB = get(b, field) ?? ''

          return order === 'desc' ? comparator(valueA, valueB) : comparator(valueB, valueA)
        },
  )
}

export default sortBy
